import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Grid, Button } from '@material-ui/core'
import { API, AUTH } from '@const'
import { AddUserDialog, EditUserDialog } from '@dialogs'
import * as utils from '@utils'
import Table from '@tables/table'
import { Edit } from '@material-ui/icons'
import { SingleConfirmMsgDialog, ConfirmMsgDialog } from '@msg'

const COMPONENT_GROUP = 'user'

class UserPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, params) => {
            return utils.t(key, 'UserPage', params)
        }
    }

    state = {
        roleList: {},
    }

    roleList = {}

    actions = []
    columns = [
        {
            field: 'account',
        },
        {
            field: 'name',
        },
        {
            field: 'role_name',
            render: (rowData) => this.state.roleList[rowData['role_id']].name,
        },
    ]

    componentDidMount() {
        this.updateTableColumns()
        this.queryRoleData(this.queryData)
    }

    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.otp_active')) {
            this.columns.push({
                field: 'otp_active',
                type: 'active',
                apiPath: API.OTP_SWITCH,
                priKey: 'account',
                apiParams: {},
                isDisabled: (rowData) => {
                    return rowData.root_role_id < 3
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.otp')) {
            this.columns.push({
                field: 'otp',
                cellStyle: {
                    textAlign: 'center',
                },
                render: (rowData) => {
                    return rowData['otp_enable'] ? (
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                this.confirmDialog.OpenDialog({
                                    type: 'info',
                                    msg: this.t('unBindConfirm', {
                                        user_name: rowData['name']
                                    }),
                                    confirm: () => {
                                        utils.apiRequest(
                                            'post',
                                            API.OTP_UNBIBDING,
                                            {
                                                account: rowData.account
                                            },
                                            () => {
                                                this.confirmDialog.closeDialog()
                                                this.queryData()
                                            }
                                        )
                                    },
                                })
                                
                            }}>
                            {this.t('unbind')}
                        </Button>
                    ) : this.t('unbound') 
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.active')) {
            this.columns.push({
                field: 'is_active',
                type: 'active',
                apiPath: API.USER_ACTIVE,
                priKey: 'account',
                isDisabled: (rowData) => {
                    return this.props.auth.isSuperUser ? false : rowData.account === AUTH.USER_ACCOUNT_ADMIN
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.reset_pwd')) {
            this.columns.push({
                field: 'reset_pwd',
                cellStyle: {
                    textAlign: 'center',
                },
                render: (rowData) => {
                    return <Button
                            color="primary"
                            onClick={() => {
                                this.confirmDialog.OpenDialog({
                                    type: 'info',
                                    msg: this.t('resetPasswordConfirm', {
                                        account: rowData['account']
                                    }),
                                    confirm: () => {
                                        utils.apiRequest(
                                            'post',
                                            API.RESET_PASSWORD,
                                            {
                                                account: rowData.account
                                            },
                                            (data) => {
                                                this.confirmDialog.closeDialog()
                                                const infoList = []
                                                infoList.push(this.t('resetPasswordSuccess'))
                                                infoList.push(`${this.t('account')}： ${rowData['account']}`)
                                                infoList.push(`${this.t('password')}： ${data.new_password}`)
                                                this.singleConfirmDialog.OpenDialog({
                                                    type: 'info',
                                                    msg: infoList.join('\n'),
                                                })
                                            }
                                        )
                                    },
                                })
                                
                            }}>
                            <Edit />
                            {this.t('resetPwd')}
                        </Button>
                
                },
            }) 
        }

        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                component: this.editDialog,
                priKey: 'account',
                isDisabled: (rowData) => {
                    return this.props.auth.isSuperUser ? false : rowData.account === AUTH.USER_ACCOUNT_ADMIN
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.columns.push({
                field: 'delete',
                type: 'delete',
                apiPath: API.USER,
                priKey: 'account',
                isDisabled: (rowData) => {
                    return rowData.account === AUTH.USER_ACCOUNT_ADMIN
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.addDialog.OpenDialog()
                },
            })
        }
    }

    queryData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.USER_LIST,
            {},
            (data) => {
                this.table.SetData(data)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    queryRoleData(callback) {
        utils.apiRequest(
            'get',
            API.ROLE_LIST,
            {},
            (data) => {		
                const roleMap = utils.ArrayToObject(utils.deepCopy(data), 'id')
                data.forEach((elem) => {
                    let roleIdName = ''
                    if (roleMap[elem['root_role_id']]) {
                        roleIdName = roleMap[elem['root_role_id']].name
                    }
					/** 只有最高權限 roleID = 2 , ID = 2 不顯示 rootRoleName */
                    const rootRoleName = (elem['root_role_id'] !== AUTH.ROLE_ID_ADMIN || elem['id'] !== AUTH.ROLE_ID_ADMIN) && !!roleIdName ? `[${roleIdName}] ` : ''
					/** roleId && id === 2 顯示 Administrator, roleId === id 為總代理 */
                    elem.name = `${rootRoleName}${elem['root_role_id'] === AUTH.ROLE_ID_ADMIN && elem['id'] === AUTH.ROLE_ID_ADMIN ? 'Administrator' : elem['root_role_id'] === elem['id'] ? this.t('rootRole') : elem.name}`
                })
                this.setState(
                    {
                        roleList: utils.ArrayToObject(data, 'id'),
                    },
                    callback
                )
            },
            (_err) => {
                this.setState({
                    roleList: {},
                })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table
                        ownerName="UserPage"
                        columns={this.columns}
                        actions={this.actions}
                        onRef={(ref) => (this.table = ref)}
                        queryDataArgs={{
                            apiPath: API.USER_LIST,
                        }}
                    />
                    <AddUserDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        roleList={this.state.roleList}
                        onRef={(ref) => (this.addDialog = ref)}
                    />
                    <EditUserDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        roleList={this.state.roleList}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                    <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)}/>
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

UserPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

export default hoc(styles)(UserPage)
